(function (app) {

    app.run([
        "AuthService", "$transitions", "$state", function (AuthService, $transitions, $state) {

            //TODO: change this to mean everything except the login/logout pages
            //currently everything falls under Home. but may not always be the case
            //TODO: include redirect info, like where the user was going so that after login they may continue 
            //TODO: or..instead of redirecting to login, have a modal come up and ask for auth?
            //that seems more like a popup warning on session timeout rather than waiting for the user
            //to change states so maybe this is fine
            $transitions.onBefore({ to: "Home.**" },
                function (transition) {
                    var redirect = $state.href(transition._targetState._definition, transition._targetState._params, transition._targetState._options);
                    if (redirect === "#") redirect = null;
                    return AuthService.isAuthenticated().then(function (isAuth) { if (!isAuth) return transition.router.stateService.target("Login", { redirect: redirect }); });
                });

            $transitions.onBefore({ to: "Login" },
                function (transition) {
                    return AuthService.isAuthenticated().then(function (isAuth) { if (isAuth) return transition.router.stateService.target("Home"); });
                });

            $transitions.onBefore({ to: "Register" },
                function (transition) {
                    return AuthService.isAuthenticated().then(function (isAuth) { if (isAuth) return transition.router.stateService.target("Home"); });
                });
            $transitions.onBefore({ to: "Invalid" },
                function (transition) {
                    return AuthService.isAuthenticated().then(function (isAuth) { if (isAuth) return transition.router.stateService.target("Home"); });
                });
        }
    ]);

    //app.run(["$trace", function($trace) { $trace.enable("TRANSITION"); }]);

})(window.app);